<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-card-title>
            <v-btn @click.stop="onAdd" color="primary" outline>
              <i class="material-icons">add</i>
              {{ $t('message.addNew')}}
            </v-btn>
            <manage-extra
              :dialog.sync="showModal"
              :isEdit.sync="isEdit"
              :isCreate.sync="isCreate"
              @on-save="onSave"
              ref="manageExtraModal"
            ></manage-extra>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              hide-details
              :label="$t('message.search')"
              single-line
              v-model="search"
            ></v-text-field>
          </v-card-title>

          <v-data-table :headers="headers" :items="extras" :search="search">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">{{ $t(`message.${props.header.text}`) }}</span>
                <span>{{ $t(`message.${props.header.text}`) }}</span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.description | shortDescription }}</td>
              <td>{{ props.item.price }}</td>
              <td>{{ props.item.catalogueName }}</td>
              <td class="text-left">
                <v-tooltip top>
                  <v-btn
                    @click="onEdit(props.item)"
                    color="primary"
                    outline
                    fab
                    icon
                    small
                    slot="activator"
                  >
                    <v-icon light>zmdi-edit</v-icon>
                  </v-btn>
                  <span>{{ $t('message.edit') }}</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-btn
                    @click="onDelete(props.item)"
                    class="trash-icon"
                    color="error"
                    outline
                    fab
                    icon
                    slot="activator"
                    small
                  >
                    <v-icon light>cancel</v-icon>
                  </v-btn>
                  <span>{{ $t('message.delete') }}</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
          <delete-confirmation-dialog
            @onConfirm="deleteExtra"
            :heading="$t('message.deleteConfirmation')"
            :message="$t('message.deleteMessage')"
            ref="deleteConfirmationDialog"
          ></delete-confirmation-dialog>
        </app-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ManageExtra from "./ManageExtra";

import {
  CREATE_EXTRA,
  UPDATE_EXTRA,
  DELETE_EXTRA,
  GET_EXTRAS
} from "../../store/modules/extras/actions.type";

export default {
  name: "extraList",
  components: {
    ManageExtra
  },
  filters: {
    shortDescription(value) {
      return value.slice(0, 40) + "...";
    }
  },
  data() {
    return {
      headers: [
        { text: "name", sortable: true, value: "name" },
        { text: "description", sortable: true, value: "description" },
        { text: "price", sortable: true, value: "price" },
        { text: "catalogue", sortable: true, value: "catalogueName" },
        { text: "actions", sortable: false, value: "" }
      ],
      search: "",
      showModal: false,
      selectedExtra: {},
      pagination: {},
      isCreate: true,
      isEdit: false
    };
  },
  computed: {
    ...mapGetters(["extras", "loadingExtras"])
  },
  created() {
    this.getExtras();
  },
  methods: {
    getExtras() {
      this.$store.dispatch(GET_EXTRAS);
    },
    deleteExtra() {
      this.$store.dispatch(DELETE_EXTRA, this.selectedExtra.id);
      this.$refs.deleteConfirmationDialog.close();
    },
    onAdd() {
      this.showModal = true;
      this.isCreate = true;
      this.isEdit = false;
    },
    onDelete(extra) {
      this.selectedExtra = extra;
      this.$refs.deleteConfirmationDialog.openDialog();
    },
    onEdit(extra) {
      //this.$store.dispatch(GET_IMAGES_PRODUCT, product.id);
      //const { full_url_image } = this.imagesProduct[0]
      this.showModal = true;
      this.isCreate = false;
      this.isEdit = true;
      this.selectedExtra = extra;


      this.$refs.manageExtraModal.setValue(extra);
    },
    async onSave(extra) {
      if (this.isCreate) {
        await this.$store.dispatch(CREATE_EXTRA, extra);
      } else {
        this.selectedExtra = Object.assign({}, this.selectedExtra, extra);
        await this.$store.dispatch(UPDATE_EXTRA, this.selectedExtra);
      }

      this.$refs.manageExtraModal.clearForm();
    }
  }
};
</script>

<style>
</style>
